import type { NoveltyCalcErrorGroup } from '@/api';
import { connectColors } from '@/theme/colors';
import { HelpText, Popover } from '@lego/connect-components-react';
import {
  formatAffectedProduct,
  formatDetail,
  formatErrorSummary,
  groupErrorCount,
  renderableProducts,
} from './group-novelty-calc-errors';

type NoveltyCalcErrorPopoverProps = {
  errors: NoveltyCalcErrorGroup[];
  isOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
};

const NoveltyCalcErrorPopover = ({
  errors,
  isOpen,
  onToggle,
  onClose,
}: NoveltyCalcErrorPopoverProps) => (
  <Popover
    renderTrigger={() => (
      <Popover.Trigger asChild onClick={onToggle}>
        <HelpText variant="negative" style={{ cursor: 'pointer' }}>
          {formatErrorSummary(errors)}{' '}
          <span
            style={{
              color: connectColors.core.blue[1000],
              textDecoration: 'underline',
            }}
          >
            see details
          </span>
        </HelpText>
      </Popover.Trigger>
    )}
    isOpen={isOpen}
    onClose={onClose}
    position="bottom"
    isRemovable
    maxWidth={500}
  >
    <Popover.Content>
      <div
        style={{
          maxHeight: '400px',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          paddingRight: '22px',
        }}
      >
        {errors.map((group, groupIndex) => (
          <div key={`${group.message}-${groupIndex}`}>
            <span className="label-sm-medium">
              {group.message} ({groupErrorCount(group)})
            </span>
            <ul
              style={{
                margin: 0,
                paddingLeft: '18px',
              }}
            >
              {renderableProducts(group).map((product, i) => {
                const detail = formatDetail(product.detail);
                return (
                  <li
                    key={`${product.productId}-${product.priceUnitId}-${i}`}
                    className="body-sm-regular"
                  >
                    {formatAffectedProduct(product)}
                    {detail && (
                      <span style={{ opacity: 0.7 }}> ({detail})</span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </Popover.Content>
  </Popover>
);

export default NoveltyCalcErrorPopover;
